/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classnames from 'classnames';
import _ from 'lodash';
import { ConfirmModal, ToggleInput } from '@/shared/ui';
import EventHrInfo from '../eventHrInfo';
import useSelectedInfo from './useSelectedInfo';

export type SelectedInfoProps = {
  ecgDataMap: any;
  timezoneOffset?: any;
};

const EVENT_CLASS_NAME = {
  'Minute info': '--minute-info-clicked',
  Artifact: '--artifact-event-clicked',
  AFib: '--afib-event-clicked',
};

/**
 * Renders the event-type tabs and detail cards for events selected on the ECG disclosure chart, plus the Set ECG disclosure confirmation. Groups the selection with useSelectedInfo, renders one tab per event type showing its count, and asks in a modal which channel should anchor the disclosure hour before confirming.
 *
 * @param props - The timezone offset and ECG context forwarded to useSelectedInfo.
 * @returns The confirmation modal together with the event info tabs and detail cards.
 */
const SelectedInfo = ({ ecgDataMap, timezoneOffset }: SelectedInfoProps) => {
  const {
    selectedColumnInfo,
    aiChannel,
    selectedEventIndex,
    setSelectedEventIndex,
    channelOptions,
    state,
    setState,
    onClickSetEcgDisclosure,
    onClickCancel,
    onClickSet,
    formatSelectedColumnInfo,
  } = useSelectedInfo({ ecgDataMap, timezoneOffset });

  return (
    <>
      <ConfirmModal
        className="set-ecg-disclosure-modal"
        isOpen={state.isOpenConfirmModal}
        title="Set ECG disclosure"
        isRedBtn={false}
        leftButtonName="Cancel"
        rightButtonName="Confirm"
        onClickLeftButton={onClickCancel}
        onClickRightButton={onClickSet}
        isBoldLeftBtn
        customContent={
          <div className="set-ecg-disclosure-content">
            <div>This position will be the start time of the ECG disclosure hour.</div>
            <div>Please select a channel to continue:</div>
            <ToggleInput
              className="input-list-item"
              name="ecgDisclosureChannel"
              options={channelOptions}
              value={state.ecgDisclosureChannel}
              onChange={(name, value) => {
                setState({ [name]: value });
              }}
            />
          </div>
        }
      />
      {!_.isEmpty(selectedColumnInfo) && (
        <div id="event-info" className="event-info-wrapper">
          <div className="event-info-tab">
            {_.map(_.keys(formatSelectedColumnInfo), (eventType, index) => {
              const { eventIndexes, events } = formatSelectedColumnInfo[eventType];
              return (
                <div
                  id={`event-selection-tab-${index}`}
                  className={classnames(
                    'tab-item',
                    (EVENT_CLASS_NAME as any)[eventType] || '--event-clicked',
                    _.includes(eventIndexes, selectedEventIndex) ? '--active' : '',
                  )}
                  onClick={() => {
                    setSelectedEventIndex(eventIndexes[0]);
                  }}
                >
                  {`${eventType}${events.length > 1 ? ` (${events.length})` : ''}`}
                </div>
              );
            })}
          </div>
          <div className="event-info-content">
            {_.map(_.keys(formatSelectedColumnInfo), (eventType) => {
              const { eventIndexes, events } = formatSelectedColumnInfo[eventType];
              return (
                <EventHrInfo
                  aiChannel={aiChannel}
                  isActive={_.includes(eventIndexes, selectedEventIndex)}
                  eventIndexes={eventIndexes}
                  events={events}
                  timezoneOffset={timezoneOffset}
                  setSelectedEventIndex={setSelectedEventIndex}
                  onClickSetEcgDisclosure={onClickSetEcgDisclosure}
                />
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default SelectedInfo;
